import React from 'react';
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SideMenu from '../../components/SideMenu';
import Table from '../../components/Table';

import BackendServices from '../../services/BackendServices';

const PAGESIZE = 3;
let globalThat;

class Item extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        filterDays: 'today',
        status: 'Aberta',
        list: [],
        type: 'geral',

        loginType: 'legal',
        enableViewRedefinePassword: true,
        password: '',
        open: false,
        step: 0,
        widthScreen: window.screen.width,
        amountOrders: 0,
        valueOrders: "0,00",
        currentPage: 1,
        pages: [1],
        allSelected: false
      };

      globalThat = this;
  }

  getInitDate() {
    let date = new Date();
    switch(this.state.filterDays){
      case "7days":
        return new Date(date.setDate(date.getDate() - 7)).toISOString() + "";
      case "15days":
        return new Date(date.setDate(date.getDate() - 15)).toISOString() + "";
      case "30days":
        return new Date(date.setDate(date.getMonth() - 1)).toISOString() + "";
      case "other":
        return new Date(date.setDate(date.getMonth() - 12)).toISOString() + "";
      default:
        return new Date(date.setDate(date.getDate() - 1)).toISOString() + "";
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let that = this;
    let queries = {
      Status: that.state.status,
      Inicio: that.getInitDate(),
      Fim: new Date().toISOString() + "",
      PageSize: PAGESIZE,
      Page: this.state.currentPage,
      OrderBy: "name"
    };

    if(this.state.type === 'geral'){
      BackendServices.getOrders(queries).then(function(res){
         let pages = [];
         for(let i=1; i<=res.data.data.totalPages; i++){
           pages.push(i);
         }
         that.setState({
           list: res.data.data,
           pages: pages,
           allSelected: false
         });
      }).catch(function(err){
        toast.error('Erro ao recuperar ordens', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
    }
    else {
      BackendServices.getHistory(queries).then(function(res){
         let pages = [];
         for(let i=1; i<=res.data.data.totalPages; i++){
           pages.push(i);
         }
         that.setState({
           list: res.data.data,
           pages: pages,
           allSelected: false
         });
      }).catch(function(err){
        toast.error('Erro ao recuperar ordens', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
    }
  }

  onChanged(item, value){
    switch(item){
      case 'list':
        let list = globalThat.state.list;
        list.results = value
        globalThat.setState({list: list});
        break;
      case 'allSelected':
        globalThat.setState({allSelected: value});
        break;
      default:
        break;
    }
  }

  setOpen(that, value){
    if(value)
      that.setState({open: value, time: 0, step: 1});
    else{
      that.setState({open: value, time: 0}, ()=> {
        setTimeout(
          () => that.setState({step: 0}),
          200
        );
      });
    }
  }

  fillLoad(dialog) {
    let that = this;
    if(this.state.load < 100){
      setTimeout(
        () => {
                that.setState({ load: that.state.load + 25 });
                that.fillLoad(dialog);
              },
        100
      );
    }
    else {
      if(dialog === 3){
        this.setState({dialog: 5});
      }
      else{
        this.setState({dialog: 6});
      }
    }
  }

  sendResetByEmail() {
    console.log("Recuperação de senha enviada!!!");
  }

  execute() {
    let that = this;
    let data = [];

    for(let i=0; i<this.state.list.results.length; i++){
      if(this.state.list.results[i].selected){
        data.push({
          id: this.state.list.results[i].id,
          provedorId: this.state.list.results[i].provedor.id,
          ticker: this.state.list.results[i].ticker,
          tipo: this.state.list.results[i].tipo,
          quantidade: this.state.list.results[i].quantidade
        });
      }
    }

    BackendServices.postOrders(data).then(function(res){
       console.log(res);
       that.getData();
       that.setState({dialog: 3, load: 0}, () => {
         that.fillLoad(3);
       });
    }).catch(function(err){
      toast.error('Erro ao executar ordens', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    });
  }

  cancel() {
    let that = this;
    let data = {
      justificativa: "Não especificado",
      ids: []
    };

    for(let i=0; i<this.state.list.results.length; i++){
      if(this.state.list.results[i].selected){
        data.ids.push(this.state.list.results[i].id);
      }
    }

    BackendServices.putOrders(data).then(function(res){
       console.log(res);
       that.getData();
       that.setState({dialog: 4, load: 0}, () => {
         that.fillLoad(4);
       });
    }).catch(function(err){
      toast.error('Erro ao cancelar ordens', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    });
  }

  openDialog(dialog){
    let amountOrders = 0;
    let valueOrders = 0;

    for(let i=0; i<this.state.list.results.length; i++){
      if(this.state.list.results[i].selected){
        amountOrders++;
        valueOrders = valueOrders + this.state.list.results[i].valor;
      }
    }

    if(amountOrders < 1){
      return toast.info('Nenhuma ordem selecionada', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    this.setState({open: true, dialog: dialog, amountOrders: amountOrders, valueOrders: valueOrders.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})});
  }

  render() {
   return (
    <section id="userPage">
      <SideMenu />

      <div className="contentData">
        <div className="contentScroll">
          <div className="contentSubData">
            <span className="desktop">
              <br/>
              <p className="title"><span style={{fontWeight: "normal"}}>Ordens |</span> Execução de ordens</p><br/>

              <div style={{justifyContent: "space-between", display: "flex"}}>
                <span>
                  <select onChange={(e)=>{let that = this; this.setState({filterDays: e.target.value, currentPage: 1}, ()=>{that.getData()});}} className="selectOrders">
                    <option value="today">Hoje</option>
                    <option value="7days">7 dias</option>
                    <option value="15days">15 dias</option>
                    <option value="30days">30 dias</option>
                    <option value="other">Outro</option>
                  </select>

                  <select style={{marginLeft: "10px", marginBottom: "10px"}}  onChange={(e)=>{let that = this; this.setState({type: e.target.value, currentPage: 1}, ()=>{that.getData()});}} className="selectOrders">
                    <option value="geral">Geral</option>
                    <option value="provedor">Provedor</option>
                  </select>

                  <div onClick={()=>{let that = this; this.setState({status: 'Aberta', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Aberta'?"itemSelected":"")} style={{marginLeft: "20px"}}>
                    Aberta
                  </div>
                  <div onClick={()=>{let that = this; this.setState({status: 'Executada', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Executada'?"itemSelected":"")}>
                    Liquidadas
                  </div>
                  <div onClick={()=>{let that = this; this.setState({status: 'Cancelada', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Cancelada'?"itemSelected":"")}>
                    Canceladas
                  </div>

                  {
                    //VERIFICAR SE MANTEM AQUI
                    // <span>
                    //   <div onClick={()=>{let that = this; this.setState({status: 'Aprovada', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Aprovada'?"itemSelected":"")}>
                    //     Aprovada
                    //   </div>
                    //   <div onClick={()=>{let that = this; this.setState({status: 'EmExecucao', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='EmExecucao'?"itemSelected":"")}>
                    //     Em execução
                    //   </div>
                    //   <div onClick={()=>{let that = this; this.setState({status: 'Erro', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Erro'?"itemSelected":"")}>
                    //     Erro
                    //   </div>
                    // </span>
                  }
                </span>

                {
                  this.state.status === 'Aberta' &&
                  <span>
                    <div onClick={()=>{this.openDialog(2);}} className="item itemCancel">
                      Cancelar
                    </div>
                    <div onClick={()=>{this.openDialog(1);}} className="item itemSelected">
                      Executar
                    </div>
                  </span>
                }
              </div>

              <Table list={this.state.list.results} onChanged={this.onChanged} status={this.state.status} allSelected={this.state.allSelected} type={this.state.type} />
            </span>


            <span className="mobile">
              <br/>
              <p className="title"><span style={{fontWeight: "normal"}}>Ordens |</span> Execução de ordens</p><br/>


              <select onChange={(e)=>{let that = this; this.setState({filterDays: e.target.value, currentPage: 1}, ()=>{that.getData()});}} className="selectOrders" style={{display: "block", margin: "0px auto 10px auto"}}>
                <option value="today">Hoje</option>
                <option value="7days">7 dias</option>
                <option value="15days">15 dias</option>
                <option value="30days">30 dias</option>
                <option value="other">Outro</option>
              </select>

              <select style={{marginLeft: "10px"}} onChange={(e)=>{let that = this; this.setState({type: e.target.value, currentPage: 1}, ()=>{that.getData()});}} className="selectOrders">
                <option value="geral">Geral</option>
                <option value="provedor">Provedor</option>
              </select>

              <div style={{justifyContent: "space-between", display: "flex", marginBottom: "10px"}}>
                <span>
                  <div onClick={()=>{let that = this; this.setState({status: 'Aberta', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Aberta'?"itemSelected":"")} style={{width: "120px"}}>
                    Aberta
                  </div>
                  <div onClick={()=>{let that = this; this.setState({status: 'Executada', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Executada'?"itemSelected":"")} style={{width: "120px"}}>
                    Liquidadas
                  </div>
                  <div onClick={()=>{let that = this; this.setState({status: 'Cancelada', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Cancelada'?"itemSelected":"")} style={{width: "120px"}}>
                    Canceladas
                  </div>

                  {
                    //VERIFICAR SE MANTEM AQUI
                    // <span>
                    //   <div onClick={()=>{let that = this; this.setState({status: 'Aprovada', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Aprovada'?"itemSelected":"")}>
                    //     Aprovada
                    //   </div>
                    //   <div onClick={()=>{let that = this; this.setState({status: 'EmExecucao', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='EmExecucao'?"itemSelected":"")}>
                    //     Em execução
                    //   </div>
                    //   <div onClick={()=>{let that = this; this.setState({status: 'Erro', currentPage: 1}, ()=>{that.getData()});}} className={"item " + (this.state.status==='Erro'?"itemSelected":"")}>
                    //     Erro
                    //   </div>
                    // </span>
                  }
                </span>
              </div>
              <div style={{justifyContent: "space-around", display: "flex"}}>
                <span>
                  <div onClick={()=>{this.openDialog(2);}} className="item itemCancel">
                    Cancelar
                  </div>
                  <div onClick={()=>{this.openDialog(1);}} className="item itemSelected">
                    Executar
                  </div>
                </span>
              </div>

              <Table list={this.state.list.results} onChanged={this.onChanged} status={this.state.status} allSelected={this.state.allSelected} type={this.state.type} />
            </span>

            <div className="contentPagesBar">
              {
                this.state.pages.map((item, index) => {
                  return <div key={index} className={"btnPage " + (item===this.state.currentPage?"itemSelected":"")} onClick={()=>{let that = this; this.setState({currentPage: item}, ()=> {that.getData()})}}>
                    {item}
                  </div>
                })
              }
            </div>
          </div>
        </div>
      </div>

      {
        this.state.widthScreen >= 0 &&
        <Transition.Root show={this.state.open} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={()=>this.setOpen(this, false)}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                    {
                      this.state.dialog === 1 &&
                      <div style={{width: "100%", maxWidth: "350px", display: "block", margin: "10px auto"}}>
                        <div style={{fontSize: "26px", textAlign: "left", marginBottom: "15px", fontWeight: "bolder"}}>
                          Confirmar
                        </div>
                        <div className="mt-2">
                          <p className="label" style={{marginBottom: "10px", fontSize: "20px", color: "#696C70"}}>Deseja <b><span style={{color: "#00E52E"}}>executar</span> {this.state.amountOrders} ordens</b> no valor total de <b>{this.state.valueOrders}?</b></p>
                          <div style={{position: "relative"}}>
                            <input
                              placeholder="Digite sua senha"
                              className="input"
                              type={(this.state.enableViewRedefinePassword?'text':'password')}
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "48%",
                                height: "45px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED",
                                display: "inline-block",
                                marginRight: "1%",
                                position: "relative",
                                top: "-3px"
                              }}></input>
                            <div
                              style={{
                                width: "48%",
                                backgroundColor: "#54E046",
                                color: "#fff",
                                borderRadius: "6px",
                                border: "2px solid #54E046",
                                height: "45px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "20px",
                                textAlign: "center",
                                display: "inline-block"
                              }}
                              className="btnLogin"
                              onClick={() => {this.execute();}}
                              >
                                Executar {this.state.amountOrders>1?"ordens":"ordem"}
                              </div>

                              {
                                this.state.enableViewRedefinePassword &&
                                <img
                                  src={require("../../assets/imgs/open-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  style={{
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "34px",
                                    left: "calc(48% - 25px)"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                                />
                              }
                              {
                                !this.state.enableViewRedefinePassword &&
                                <img
                                  src={require("../../assets/imgs/close-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  style={{
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "37px",
                                    left: "calc(48% - 25px)"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                                />
                              }
                            </div>

                            <div
                              style={{
                                width: "100%",
                                maxWidth: "290px",
                                color: "#54E046",
                                borderRadius: "6px",
                                height: "50px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "0px",
                                textAlign: "left"
                              }}
                              className="btnLogin"
                              onClick={() => {this.sendResetByEmail();}}
                              >
                                Esqueci minha senha
                              </div>

                              <div
                                style={{
                                  width: "100%",
                                  maxWidth: "290px",
                                  color: "#54E046",
                                  borderRadius: "6px",
                                  height: "50px",
                                  fontWeight: "bolder",
                                  cursor: "pointer",
                                  paddingTop: "10px",
                                  marginTop: "20px",
                                  textAlign: "left"
                                }}
                                className="btnLogin"
                                onClick={()=>this.setOpen(this, false)}
                                >
                                  <img src={require("../../assets/imgs/seta.svg").default} alt="Voltar" className="iconClose" style={{display: "inline-block", position: "relative", top: "-2px"}}/>&nbsp;
                                  Voltar
                                </div>
                        </div>
                      </div>
                    }
                    {
                      this.state.dialog === 2 &&
                      <div style={{width: "100%", maxWidth: "350px", display: "block", margin: "10px auto"}}>
                        <div style={{fontSize: "26px", textAlign: "left", marginBottom: "15px", fontWeight: "bolder"}}>
                          Confirmar
                        </div>
                        <div className="mt-2">
                          <p className="label" style={{marginBottom: "10px", fontSize: "20px", color: "#696C70"}}>Deseja <b><span style={{color: "#FF460C"}}>cancelar</span> {this.state.amountOrders} ordens</b> no valor total de <b>{this.state.valueOrders}?</b></p>
                          <div style={{position: "relative"}}>
                            <input
                              placeholder="Digite sua senha"
                              className="input"
                              type={(this.state.enableViewRedefinePassword?'text':'password')}
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "48%",
                                height: "45px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED",
                                display: "inline-block",
                                marginRight: "1%",
                                position: "relative",
                                top: "-3px"
                              }}></input>
                            <div
                              style={{
                                width: "48%",
                                backgroundColor: "#FF460C",
                                color: "#fff",
                                borderRadius: "6px",
                                border: "2px solid #FF460C",
                                height: "45px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "20px",
                                textAlign: "center",
                                display: "inline-block"
                              }}
                              className="btnLogin"
                              onClick={() => {this.cancel();}}
                              >
                                Cancelar {this.state.amountOrders>1?"ordens":"ordem"}
                              </div>

                              {
                                this.state.enableViewRedefinePassword &&
                                <img
                                  src={require("../../assets/imgs/open-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  style={{
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "34px",
                                    left: "calc(48% - 25px)"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                                />
                              }
                              {
                                !this.state.enableViewRedefinePassword &&
                                <img
                                  src={require("../../assets/imgs/close-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  style={{
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "37px",
                                    left: "calc(48% - 25px)"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                                />
                              }
                            </div>

                            <div
                              style={{
                                width: "100%",
                                maxWidth: "290px",
                                color: "#54E046",
                                borderRadius: "6px",
                                height: "50px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "0px",
                                textAlign: "left"
                              }}
                              className="btnLogin"
                              onClick={() => {this.sendResetByEmail();}}
                              >
                                Esqueci minha senha
                              </div>

                              <div
                                style={{
                                  width: "100%",
                                  maxWidth: "290px",
                                  color: "#54E046",
                                  borderRadius: "6px",
                                  height: "50px",
                                  fontWeight: "bolder",
                                  cursor: "pointer",
                                  paddingTop: "10px",
                                  marginTop: "20px",
                                  textAlign: "left"
                                }}
                                className="btnLogin"
                                onClick={()=>this.setOpen(this, false)}
                                >
                                  <img src={require("../../assets/imgs/seta.svg").default} alt="Voltar" className="iconClose" style={{display: "inline-block", position: "relative", top: "-2px"}}/>&nbsp;
                                  Voltar
                                </div>
                        </div>
                      </div>
                    }
                    {
                      (this.state.dialog === 3 || this.state.dialog === 4) &&
                      <div style={{width: "100%", maxWidth: "350px", display: "block", margin: "10px auto"}}>
                        <div style={{fontSize: "26px", textAlign: "left", marginBottom: "15px", fontWeight: "bolder"}}>
                          {this.state.dialog === 3?"Executando":"Cancelando"} ordens
                        </div>

                        <div className="mt-2">
                          <div
                            style={{
                              fontSize: "16px",
                              color: "#131C29",
                              padding: "10px"
                            }}
                          >
                            Por favor, aguarde...
                          </div>
                          <div
                            style={{
                              width: "100%",
                              height: "5px",
                              backgroundColor: "#EBEBED",
                              borderRadius: "5px",
                              position: "relative"
                            }}
                            >
                            <div
                              style={{
                                width: this.state.load + "%",
                                height: "100%",
                                left: "0px",
                                top: "0px",
                                backgroundColor: "#54E046",
                                borderRadius: "3px",
                                position: "absolute"
                              }}
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    {
                      (this.state.dialog === 5 || this.state.dialog === 6) &&
                      <div style={{width: "100%", maxWidth: "350px", display: "block", margin: "10px auto"}}>
                        <div style={{textAlign: "center", marginBottom: "15px", color: "#131C29"}}>
                          <img src={require("../../assets/imgs/check.svg").default} alt="Close" className="iconClose" style={{display: "inline-block", position: "relative", top: "-2px"}}/><br/>
                          <b style={{fontSize: "24px"}}>Ordens {this.state.dialog === 5?"Executadas":"Canceladas"} com sucesso</b>
                        </div>

                        <div
                          style={{
                            width: "100%",
                            maxWidth: "160px",
                            backgroundColor: "#ffffff",
                            color: "#54E046",
                            borderRadius: "6px",
                            border: "2px solid #54E046",
                            height: "50px",
                            fontWeight: "bolder",
                            cursor: "pointer",
                            paddingTop: "10px",
                            margin: "20px auto 10px auto",
                            textAlign: "center",
                            display: "block"
                          }}
                          className="btnLogin"
                          onClick={()=>this.setOpen(this, false)}
                          >
                            Ver ordens
                          </div>
                      </div>
                    }
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      }
      <ToastContainer />
    </section>
   );
  }
 }

export default Item;
